"use strict";
export default (() => {
  var _a;
  const BootstrapTooltip = ((_a = window.bootstrap) == null ? void 0 : _a.Tooltip) || Tooltip;
  const tooltipTriggerList = document.querySelectorAll(
    '[data-bs-toggle="tooltip"]'
  );
  const tooltipList = [...tooltipTriggerList].map(
    (tooltipTriggerEl) => new bootstrap.Tooltip(tooltipTriggerEl, { trigger: "hover" })
  );
})();
